import {connect} from 'react-redux';
import CountryFieldComponent from './countryImpl';

const mapStateToProps = (state, props) => ({
  ...props,
  countries: state.locale.countriesForBuyers
});

export default connect(mapStateToProps)(CountryFieldComponent);
